export const convertPassengerTypeName = (t: any, type: number) => {
	return ['', t('home.chengren'), t('home.xiaotong'), t('home.yinger'), t('home.guyong'), t('home.haiyuan')][type];
};
export const passengerTypeList = (t: any) => {
	return [{
		label: t('home.chengren'),
		subLabel: t('home.nianling') + ' 12+',
		value: 'adultNum',
		icon: 'tt-adult',
		actNum: 1,
	}, {
		label: t('home.xiaotong'),
		subLabel: t('home.nianling') + ' 2-11',
		value: 'childrenNum',
		icon: 'tt-child',
		actNum: 0,
	}, {
		label: t('home.yinger'),
		subLabel: '<2 ' + t('home.sui'),
		value: 'infantNum',
		icon: 'tt-infant',
		actNum: 0,
		// }, {
		// 	label: t('home.xuesheng'),
		// 	value: 'studentNum',
		// 	actNum: 0,
		// },  {
		// 	label: t('home.guyong'),
		// 	value: 'helperNum',
		// 	actNum: 0,
		// }, {
		// 	label: t('home.haiyuan'),
		// 	value: 'seamenNum',
		// 	actNum: 0,
	}];
};
